import { render, staticRenderFns } from "./CardAnalyticAvgSessions.vue?vue&type=template&id=289cea0a&"
import script from "./CardAnalyticAvgSessions.vue?vue&type=script&lang=js&"
export * from "./CardAnalyticAvgSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports